function decodeBase64ToBlob(base64) {
  const binary = window.atob(base64)
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0))
  return new Blob([bytes], { type: 'application/pdf' })
}

export function normalizePdfSource(payload = {}) {
  if (payload?.url) {
    return {
      viewUrl: payload.url,
      revoke() {},
    }
  }

  const blob = payload?.blob || (payload?.pdfBase64 ? decodeBase64ToBlob(payload.pdfBase64) : null)

  if (!(blob instanceof Blob)) {
    throw new Error('PDF payload không hợp lệ')
  }

  const viewUrl = window.URL.createObjectURL(blob)

  return {
    viewUrl,
    revoke() {
      window.URL.revokeObjectURL(viewUrl)
    },
  }
}

export function downloadPdfUrl(url, downloadName) {
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', downloadName)
  document.body.appendChild(link)
  link.click()
  link.remove()
}

export function printPdfUrl(url) {
  const iframe = document.createElement('iframe')
  iframe.style.position = 'fixed'
  iframe.style.right = '0'
  iframe.style.bottom = '0'
  iframe.style.width = '0'
  iframe.style.height = '0'
  iframe.style.border = '0'
  iframe.src = url
  iframe.setAttribute('aria-hidden', 'true')
  document.body.appendChild(iframe)

  return new Promise((resolve, reject) => {
    let settled = false

    const cleanup = () => {
      setTimeout(() => {
        try {
          document.body.removeChild(iframe)
        } catch (error) {
          void error
        }
      }, 1000)
    }

    iframe.onload = () => {
      try {
        const target = iframe.contentWindow
        if (!target) {
          throw new Error('Không thể truy cập cửa sổ in PDF')
        }

        target.focus()
        target.print()
        settled = true
        resolve()
      } catch (error) {
        settled = true
        reject(error)
      } finally {
        cleanup()
      }
    }

    iframe.onerror = () => {
      if (settled) return
      cleanup()
      reject(new Error('Không thể tải tài liệu để in'))
    }
  })
}
